import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiLeetcode, SiHackerrank } from "react-icons/si";

const ContactData = {
  phone: "+91-9767910617",
  email: "omnbhaltilak@gmail.com",
  address: "Pune, Maharashtra, India",
  links: [
    {
      url: "https://www.linkedin.com/in/om-bhaltilak-377ba9259/",

      
      icon: FaLinkedin,
    },
    {
      url: "https://github.com/ombhaltilak",
      icon: FaGithub,
    },
    {
      url: "https://leetcode.com/u/omnbhaltilak/",
      icon: SiLeetcode,
    },
    {
      url: "https://www.hackerrank.com/profile/omnbhaltilak",
      icon: SiHackerrank,
    },
  ],
};

export default ContactData;